import { AsyncPipe, NgClass, NgComponentOutlet, NgForOf, NgIf } from '@angular/common';
import { Component, ElementRef, inject, OnInit, ViewChild, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '@lx/shared/ui/button';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { QuoteToolLiteStore } from '../../store';
import { NavigationBarItem, RouteIds, Step } from '../../types';
import { NavigationBarComponent } from '../navigation-bar/navigation-bar.component';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { NavigationToStepDirective } from '../../directives';
import { CopyQuoteSelectionsButtonComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { toSignal } from '@angular/core/rxjs-interop';
import { Flows, Flow } from '@lx/quote-tool/lite/shared/types';
import { AcquisitionDisclaimerWidgetService } from '@lx/quote-tool/shared/services';
import { CopyQuoteSelectionsService } from '@lx/quote-tool/lite/shared/services';
import { DeeplinkGeneratorService } from '../../services';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    ButtonComponent,
    NgIf,
    AsyncPipe,
    NgComponentOutlet,
    NgClass,
    NgForOf,
    NavigationBarComponent,
    NavigationToStepDirective,
    CopyQuoteSelectionsButtonComponent,
  ],
  selector: 'lx-step-wrapper',
  templateUrl: './step-wrapper.component.html',
  styleUrls: ['./step-wrapper.component.scss'],
})
export class StepWrapperComponent implements OnInit {
  @ViewChild('acquisitionDisclaimerContainer', { static: true }) acquisitionDisclaimerContainer: ElementRef<HTMLElement> | undefined;

  currentStep$: Observable<Step> | undefined;
  activeFlow$: Observable<Flow> | undefined;

  navigationBarItems$: Observable<NavigationBarItem[]>;

  nextDataLayerEventName = GoogleAnalyticsEventEnum.QuoteNext;

  nextStep$: Observable<Observable<RouteIds>> | undefined;

  protected readonly Flows = Flows;
  protected readonly valid: Signal<boolean | null>;
  protected readonly copied: Signal<boolean | undefined>;

  private readonly deeplinkService = inject(DeeplinkGeneratorService);
  private readonly copyService = inject(CopyQuoteSelectionsService);
  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);
  private readonly acquisitionDisclaimerWidgetService = inject(AcquisitionDisclaimerWidgetService);

  constructor() {
    this.valid = toSignal(this.deeplinkService.isValid$, { initialValue: null });
    this.copied = this.copyService.copied;
  }

  ngOnInit(): void {
    this.currentStep$ = this.quoteToolLiteStore.currentStep$;
    this.navigationBarItems$ = this.quoteToolLiteStore.currentStep$.pipe(switchMap((step) => of(step?.navigationBarItems ?? [])));
    this.activeFlow$ = this.quoteToolLiteStore.activeFlow$;

    this.nextStep$ = this.quoteToolLiteStore.currentStepNextRouteId$;

    this.acquisitionDisclaimerWidgetService.loadWidget(this.acquisitionDisclaimerContainer);
  }

  protected handleCopyRequested(): void {
    this.copyService.handleCopyRequested(this.deeplinkService.generateDeeplink(), GoogleAnalyticsEventEnum.CopyLinkClicked);
  }
}
